"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=role.dto.js.map